import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

const SubmissionSuccess = () => (
  <div className="min-h-screen bg-[#FAF9F7] flex items-center justify-center px-4">
    <div className="max-w-lg text-center" data-testid="submission-success">
      <div className="w-20 h-20 bg-[#DE92A9] rounded-full flex items-center justify-center mx-auto mb-6">
        <CheckCircle className="text-white" size={40} />
      </div>
      <h1
        className="text-3xl md:text-4xl text-[#2C2C2C] mb-4"
        style={{ fontFamily: '"Playfair Display", serif' }}
      >
        Thank You!
      </h1>
      <p className="text-[#6B4E37] mb-6">
        Your wedding story submission has been received. We're so excited to hear about your special day!
        Our team will be in touch soon.
      </p>
      <p className="text-[#DE92A9] font-medium mb-8">
        Don't forget to send your photos to:
        <br />
        <a
          href="mailto:idobridalmagazinemalta@gmail.com"
          className="underline hover:opacity-80"
        >
          idobridalmagazinemalta@gmail.com
        </a>
      </p>
      <Link to="/">
        <Button className="bg-[#DE92A9] hover:bg-[#C9758F] text-white px-8 py-3">
          Return Home
        </Button>
      </Link>
    </div>
  </div>
);

export default SubmissionSuccess;
